module.exports = __webpack_public_path__ + "images/status-cancel.b5c43d17.png";